export default __webpack_public_path__ + "static/media/3-Cloudxier-AdventureIndonesia.9a76fa1c.png";